import { createQueryKeys } from '@lukemorales/query-key-factory';

export const externalServices = createQueryKeys('externalServices', {
  fns: (value: string) => [value],
  geoapify: (value: string) => [value],
  microlink: (url: string) => [url],
});
